import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'

import moment from 'moment'

// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))
class DoctorAdvertisementRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('doctorAdvertisements')

        return this
    }

    all (onSuccess, onError) {
        db.collection('doctorAdvertisements')
            .get()
            .then((querySnapshot) => {
                let doctorAdvertisements = []

                querySnapshot.forEach((doc) => {
                    let doctorAdvertisement = doc.data()

                    doctorAdvertisements.push(doctorAdvertisement)
                });

                onSuccess(doctorAdvertisements)
            })
            .catch((error) => {
                if (typeof onError != 'undefined') {
                    onError(error)
                } else {
                    console.error(error)
                }
            })
    }

    allForDoctor (doctor, onSuccess, onError) {
        db.collection('doctorAdvertisements')
            .where('countryId', '==', doctor.countryId)
            .where('medicalPractices', 'array-contains', doctor.type)
            .get()
            .then((querySnapshot) => {
                let doctorAdvertisements = []

                querySnapshot.forEach((doc) => {
                    let doctorAdvertisement = doc.data()

                    doctorAdvertisements.push(doctorAdvertisement)
                });

                onSuccess(doctorAdvertisements)
            })
            .catch((error) => {
                if (typeof onError != 'undefined') {
                    onError(error)
                } else {
                    console.error(error)
                }
            })
    }

    create ({countryId, name}, onSuccess, onError) {
        var doctorAdvertisementDocs = {}

        var doctorAdvertisementRef = db.collection('doctorAdvertisements').doc()

        this.collection.doc(doctorAdvertisementRef.id)
            .set({
                id: doctorAdvertisementRef.id,
                name: name,
                countryId: countryId,
                isPublished: false,
                position: 999,
                items: {}
            })
            .then(() => {
                onSuccess(doctorAdvertisementRef.id)
            })
            .catch(onError);
    }

    update (doctorAdvertisement, onSuccess, onError) {
        this.collection.doc(doctorAdvertisement.id)
            .update(doctorAdvertisement)
            .then(() => {
                onSuccess(doctorAdvertisement.id)
            })
            .catch(onError);
    }

    delete (id, onSuccess, onError) {
        this.collection.doc(id)
            .delete()
            .then(onSuccess)
            .catch(onError);
    }

    find (id, onSuccess, onError) {
        this.collection.doc(id)
            .get()
            .then((snapshot) => {
                if (snapshot.exists) {
                    onSuccess(snapshot.data())
                } else {
                    onError({message: "This doctor advertisement does not exist."})
                }
            })
            .catch(onError)
    }
}

export default new DoctorAdvertisementRepository()


// WEBPACK FOOTER //
// ./src/data/DoctorAdvertisementRepository.js